import React from 'react';
import AccommodationCalendar from './AccommodationCalendar';

const AccommodationCalendarWrapper = () => {
  return <AccommodationCalendar />;
};

export default AccommodationCalendarWrapper;
